import api from '../../api/index.js'

const state = {
    
}

const getters = {

}

const actions = {
    GetProductPosterQRcode({commit},payload) {
        return new Promise((resolve, reject) => {
            api.get('/MemberPoster/GetProductPosterQRcode',payload, res => {
                resolve(res);
            }, err => {
                reject(err);
            })
        })
    },

}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/memberPoster.js